import styled from 'styled-components';
export const Container = styled.div`
  display:${({ visibility }) => visibility ? ' ' : 'none'};
  width: 100%;
  height:100%;
  overflow: hidden;
  padding: 0.5rem;

  .isLoading{
    pointer-events: none;
  }
`;
export const Content = styled.div`
  width: 100%;
  height: calc(100% - 4rem);
  margin-top: 4rem;
  overflow-y:auto;
  overflow-x:hidden;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`;
export const Filters = styled.div`
  position: absolute;
  display: flex;
  width: auto;
  height: auto;
  gap: 1rem;
  .isLoading{
    pointer-events: none;
  }
  .center___{
    justify-content: center;
    align-items: center;
  }
  .filterByContact{
    display: flex;
    width:100%;
    height: 200px;
    background: red;
  }
  .effect{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;
export const Box1 = styled.div`
  display: flex;
  width: 27rem;
  height: 3.5rem;
  padding: 0.5rem;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 3px;
  background-color: #1D86FF;
`;
export const Box2 = styled.div`
  display: flex;
  width: 27rem;
  height: auto;
  padding: 0.5rem;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 3px;
  background-color: #1D86FF;
`;
export const OptionFilter = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    flex-direction: row;
    gap: 0.75rem;
    .hidden--{
      visibility: hidden;
    }
    .title{
      display: flex;
      max-width: 50px;
      margin-left:5px;
      justify-content: center;
      align-items: center;
    }
    .xlss-b{
      position: relative;
      display: flex;
      width: 100%;
      .xlss-l{
        display: flex;
        width: 100%;
        height: 2.5rem;
        background-color: #ffffff;
        border-radius: 3px;
        padding: 0.2rem;
        color: #000000;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        .selected--{
          padding: 0 0.5rem;
        }
      }
      .xlss-a{
        z-index: 9;
        position: absolute;
        width: 100%;
        height: 250px;
        top: 35px; 
        background-color: #ffffff;
        padding: 5px;
        box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
        color: #000000;
        border-radius:4px; 
      }
    }
`;
export const Line = styled.div`
  display: flex;
  width: 100%;
  height: 2.5rem;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
`;
export const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  input{
    outline: none;
    border: none;
    width: 50%;
    height: 2.5rem;
    text-align: center;
    cursor: pointer;
    border-radius: 3px;
    padding: 0 0.5rem;
  };
  .actions--{
    display: flex;
    justify-content:space-between;
    width: 45%;
  }
  .apply{
    display: flex;
    width: 120px;
    height: 2.5rem;
    border-radius: 3px;
    justify-content: center;
    align-items: center;
    background-color: #1D86FF;
    color: #d5f6f2;
    cursor: pointer;
    font-weight: bolder;
    &:hover{
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  .clear{
    display: flex;
    width: 40px;
    height: 2.5rem;
    border-radius: 3px;
    justify-content: center;
    align-items: center;
    background-color: #ffff00;
    color: #8f8f21;
    cursor: pointer;
    &:hover{
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

`;
export const ActionDown = styled.div`
  display: flex;
  width: 2.5rem;
  height: 100%;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  cursor: pointer;
  color: #ffffff;
  background-color: #1D86FF;
  &:hover{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;
export const ButtonSearch = styled.div`
  display: flex;
  width: 2.5rem;
  height: 100%;
  border-radius: 3px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ffffff;
  background-color: #1D86FF;
  &:hover{
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;
export const Load = styled.div`
  border: 2px solid #ffffff; 
  border-top: 2px solid #0000; 
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin-left: 2px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

